import Ball from '../ball/Ball';
import { createAllPins } from '../board/CreateAllPins';

export default function componentDidUpdate() {
  if (this.state.coeffs.toString() !== this.props.coeffs.toString()) {
    this.setState({
      coeffs: this.props.coeffs,
    });
  }

  if (this.state.risk.toString() !== this.props.risk.toString()) {
    this.setState({
      risk: this.props.risk,
    });
  }

  if (this.state.rows.toString() !== this.props.rows.toString()) {
    this.setState({
      rows: this.props.rows,
      board: createAllPins(this.props.rows, 315),
    });
  }

  if (this.state.wheelCoefs.toString() !== this.props.wheelCoefs.toString()) {
    this.setState({
      wheelCoefs: this.props.wheelCoefs,
    });
  }

  if (this.state.lastPath.toString() !== this.props.path.toString()) {
    // Adding ball
    let path = this.props.path;
    path.length = this.state.rows;
    const ball = new Ball(
      this.state.board[0][1].x,
      0,
      path,
      this.ctx,
      this.state.rows,
      this.removeBall,
      this.state.coeffs,
      this.props.handleFinish,
      this.props.speed,
      this.props.ballBalance,
      this.props.winBalance
    );
    ball.fall();
    this.balls.push(ball);
    this.setState({ lastPath: this.props.path });
  }
}
